<template>
  <div>
    <div class="detailsBox" v-if="loaded && editable">
      <richTextEditor :ori.sync="description"></richTextEditor>
    </div>
    <div class="readonly-wrap" v-if="!editable">
      <div v-html="description" v-if="description"></div>
      <div v-else class="no-data">
        <img
          class="icon"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/integral/no-data.png"
          width="101"
          height="154"
        />
        <p class="text">暂无介绍</p>
      </div>
    </div>
    <div
      v-if="editable"
      class="mwow-button-filled success editbtnpost"
      @click="postedit()"
      v-debounce="1000"
    >
      保存
    </div>
  </div>
</template>
<script>
import { modifyDetail } from "@/api/teacherManage";
import richTextEditor from "@/components/richTextEditor.vue";
export default {
  components: {
    richTextEditor,
  },
  props: ["originData", "readonly"],
  data() {
    return {
      loaded: false,
      description: "",
    };
  },
  watch: {
    originData(n, o) {
      if (o === undefined) {
        this.loaded = true;
        this.description = n;
      }
    },
  },
  computed: {
    editable() {
      return this.readonly === 1;
    },
  },
  methods: {
    postedit() {
      const html = this.description
        .replace(/<\/?p[^>]*>/gi, "")
        .replace(/&nbsp;/g, "")
        .trim();
      if (html == "") {
        this.$message({
          type: "error",
          message: "请输入教师详情",
        });
        return;
      }
      modifyDetail({
        staff_id: Number(this.$route.query.id),
        detail: this.description,
      }).then((res) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.detailsBox {
  position: relative;
  .SizeTishi {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
  .myQuillEditor {
    height: 250px;
    /deep/.ql-container {
      height: 83% !important;
    }
  }
}
.editbtnpost {
  margin-top: 10px;
  margin-right: 0;
}
/deep/.readonly-wrap {
  overflow: hidden auto;
  border: 1px solid #e7e8ea;
  padding: 24px;
  line-height: 1.5 !important;
  h1 {
    font-size: 32px;
  }
  h2 {
    font-size: 28px;
  }
  h3 {
    font-size: 24px;
  }
  h4 {
    font-size: 20px;
  }
  h5 {
    font-size: 16px;
  }
}
.no-data {
  text-align: center;
  padding: 32px 0;
  .icon {
    width: 140px;
    height: auto;
  }
  .text {
    font-size: 14px;
    color: #333;
    margin-top: 24px;
  }
}
</style>
